import BaseInfoBox from "../BaseInfoBox";
import HTPFirstPart from "../HTPFirstPart";

export default class WinningElmInfo extends BaseInfoBox {
  private HTPFirstPart = HTPFirstPart.getInstance();
  constructor() {
    super();
    this.addCoord(0, -50);
    this.addBg(440, 100, 0x6b6ea1, 0x7b7eb1)
    this.addText("THE BIG FIREWORKS IS THE WINNING SYMBOL.", 50, 420);
    this.addToCon();
    this.scale.set(this.startScale);
    this.visible = false;
  }
  addToCon() {
    this.HTPFirstPart.addChild(this);
  }
}